// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 63 ? "ImportFuncDemo" : chunkId) + "." + {"63":"95833a75","679":"25dd9adb","719":"a7fc3a4b"}[chunkId] + ".js";
};